module.exports = __webpack_public_path__ + "img/plants.ef1a000e.png";